import { Component, h, Host, Prop, State, Watch } from '@stencil/core';
import get from 'lodash/get';
import { getCookie } from '../../../../../shared/helpers/cookie.helper';
import { HttpService } from '../../../../../apps/website-frontend/src/ts/helpers/http.helper';
import { remapArrayErrors } from '../../utils/utils';
import { backToStockValidationErrors } from './consts/validations-error.const';
import { sdkLogHelper } from '../../../../../shared/helpers/sdk-log.helper';
import { TrackerEventsEnum } from '../../../../../shared/models/tracker-events.enum';

enum TypeOfPageEnum {
  productInfo = 'productInfo',
  product = 'product'
}

@Component({
  tag: 'back-to-stock',
  styleUrl: 'back-to-stock.scss',
})
export class BackToStock {
  @Prop() isProductInfoPage: boolean = false;
  @Prop() productName: string;
  @Prop() productId: string;
  @Prop() validationError: string;

  @State() isModalVisible: boolean = false;

  @Watch('validationError')
  onValidationError(val: string) {
    this.validationError = val;
  }

  get isAuthorized(): boolean {
    return !!getCookie('x-jwt-token');
  }

  get isBackToStockShown(): boolean {
    return !!sessionStorage.getItem(`is_back_to_stock_product_shown_${this.productId}`);
  }

  translate = (key) => {
    return get(window['webcomponentBackToStockModal'], key, key);
  }

  toggleModal(type: string) {
    this.sendEventsToTracker(type);
    this.isModalVisible = !this.isModalVisible;

    if (this.isAuthorized) {
      this.onSetDataForAuthorizedUser();
    }
  }

  setDataToSessionStorage() {
    sessionStorage.setItem(`is_back_to_stock_product_shown_${this.productId}`, 'true');
  }

  onSetDataForAuthorizedUser() {
    const email = null;
    this.setBackToStock(email)
      .then(() => this.setDataToSessionStorage())
      .catch(() => this.setDataToSessionStorage());
  }

  onSetBackToStock(email: string | null) {
    this.setBackToStock(email)
      .then(() => {
        this.setDataToSessionStorage();
        this.isModalVisible = false;
        sdkLogHelper(this.isProductInfoPage
          ? TrackerEventsEnum.productViewNotifyUnauthorisedConfirmed
          : TrackerEventsEnum.previewNotifyAuthorisedConfirmed,
{
          productId: this.productId,
          productName: this.productName,
        })
      }).catch((e) => {
        if (e?.exception?.message) {
          this.setDataToSessionStorage();
        }
        const errors = remapArrayErrors(backToStockValidationErrors, e?.violations?.map(err => err?.reason));
        this.validationError = this.translate(errors?.[0]) || e?.exception?.message || this.translate('validationsErrors.baseMessage');
    });
  }

  setBackToStock(email: string | null) {
    const url = `${window['apomedsConfigs'].apiUrl}/workflow/public/users/interests`;
    const token = getCookie('x-jwt-token');
    const headers = token ? { 'x-jwt-token': `Bearer ${token}`} : {};
    const body = {
      'type': 'back_to_stock',
      'product_id': this.productId,
      'product_name': this.productName,
      'email': email
    }

    return HttpService.post(url, body, headers);
  }

  sendEventsToTracker(type: string) {
    const data = {
      productId: this.productId,
      productName: this.productName,
    }

    if (this.isAuthorized) {
      if (type === TypeOfPageEnum.productInfo) {
        sdkLogHelper(TrackerEventsEnum.productViewNotifyAuthorised, data);
      }

      if (type === TypeOfPageEnum.product) {
        sdkLogHelper(TrackerEventsEnum.previewNotifyAuthorised, data);
      }
    } else {
      if (type === TypeOfPageEnum.productInfo) {
        sdkLogHelper(TrackerEventsEnum.productViewNotifyUnauthorised, data);
      }

      if (type === TypeOfPageEnum.product) {
        sdkLogHelper(TrackerEventsEnum.previewNotifyUnauthorised, data);
      }
    }
  }


  render() {
    return !this.isBackToStockShown && <Host>
      {
        this.isProductInfoPage
          ? <div class="btn-orange btn-notify info" onClick={() => this.toggleModal(TypeOfPageEnum.productInfo)}>
              <span class='icon'></span>
              <span class='text'>{this.translate('productInfoBtnTitle')}</span>
            </div>
          : <div class="btn-orange-stroke btn-notify" onClick={() => this.toggleModal(TypeOfPageEnum.product)}>
              <span class='icon'></span>
              <span class='text'>{this.translate('productBtnTitle')}</span>
            </div>
      }
      {
        this.isAuthorized
          ? this.isModalVisible && <authorized-user-modal product-name={this.productName}
                                                          onModalClose={() => this.isModalVisible = false}
                                   ></authorized-user-modal>
          : this.isModalVisible && <not-authorized-user-modal product-name={this.productName}
                                                              validation-error={this.validationError}
                                                              onModalClose={() => this.isModalVisible = false}
                                                              onValidationErrorChanged={() => this.validationError = ''}
                                                              onSetBackToStock={(e: CustomEvent) => this.onSetBackToStock(e.detail)}
                                   ></not-authorized-user-modal>
      }
    </Host>
  }
}
